import { processRoutesToRemoveSchoolLocation } from "../tools";
import moment from "moment/moment";
import fileDownload from "js-file-download";
import { Parser } from "json2csv";
import { Button } from "react-admin";

interface ExportRouteInCsvButtonProps {
  selectedData: any;
  school: any;
  busSchedule: any;
}

const ExportRouteInCsvButton = ({
  selectedData,
  school,
  busSchedule,
}: ExportRouteInCsvButtonProps) => {
  const handleGenerateCsv = async (route: any) => {
    // Used to display custom column header label
    let routeLabel = "PM";
    let timeLabel = "PM Drop-Off Time";
    let pointLabel = "PM Drop-Off Point";
    if (busSchedule.type === "to_school") {
      routeLabel = "AM";
      timeLabel = "AM Pick-Up Time";
      pointLabel = "AM Pick-Up Point";
    }

    const dataRows = processRoutesToRemoveSchoolLocation(
      [route],
      busSchedule.type,
    )[0].routeLocations.flatMap((item: any) => {
      return item.students
        .sort((a: any, b: any) => a.id - b.id)
        .map((data: any) => {
          return {
            "Location Code": data.locationCode,
            "First Name": data.firstName,
            "Last Name": data.lastName,
            Gender: data.gender,
            "Blk/Hse No": item.blockNumber,
            "Street Address": item.street,
            Building: item.building,
            "Postal Code": item.postalCode,
            [routeLabel]: route.name,
            [timeLabel]: moment(item.arrivedAt, "HH:mm").format("hh:mm A"),
            [pointLabel]: item.remark !== null ? item.remark : "",
          };
        });
    });

    const parser = new Parser();
    fileDownload(
      parser.parse(dataRows),
      `${school.name}_${routeLabel}_${
        route.name
      }_${moment().format("YYYYMMDDHHmmss")}.csv`,
    );
  };

  return (
    <Button
      label="Export Route in CSV"
      onClick={() => {
        handleGenerateCsv(selectedData);
      }}
    />
  );
};

export default ExportRouteInCsvButton;
